import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import storage from './storage'

// import Auth views
import Login from '@imemento/spa-helpers/src/views/auth/Login'
import RecoverPassword from '@imemento/spa-helpers/src/views/auth/RecoverPassword'
import Register from '@imemento/spa-helpers/src/views/auth/Register'
import ResetPassword from '@imemento/spa-helpers/src/views/auth/ResetPassword'
import InsufficientPrivileges from '@imemento/spa-helpers/src/views/auth/InsufficientPrivileges'

// import App views
import Users from './views/app/Users.vue'
import Services from './views/app/Services.vue'
import Organizations from './views/app/Organizations.vue'
import Events from './views/app/Events'
import Listeners from './views/app/Listeners'

// import Healthy view
import Healthy from '@imemento/spa-helpers/src/views/healthy/Healthy'

// the router instance
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/authentication/login',
      component: Login,
      meta: { private_route: false }
    },
    {
      path: '/authentication/recover-password',
      component: RecoverPassword,
      meta: { private_route: false }
    },
    {
      path: '/authentication/register',
      component: Register,
      meta: { private_route: false }
    },
    {
      path: '/authentication/reset-password',
      component: ResetPassword,
      meta: { private_route: false }
    },
    {
      path: '/authentication/insufficient-privileges',
      component: InsufficientPrivileges,
      meta: { private_route: false }
    },
    {
      path: '/healthy',
      component: Healthy,
      meta: { private_route: false }
    },
    {
      path: '/',
      redirect: '/users'
    },
    {
      path: '/users',
      component: Users,
      meta: { private_route: true }
    },
    {
      path: '/services',
      component: Services,
      meta: { private_route: true }
    },
    {
      path: '/organizations',
      component: Organizations,
      meta: { private_route: true }
    },
    {
      path: '/events',
      component: Events,
      meta: { private_route: true }
    },
    {
      path: '/listeners',
      component: Listeners,
      meta: { private_route: true }
    },

  ]
});

// router before middleware
router.beforeEach(async (to, from, next) => {

  if (to.path === '/healthy') {
    return next();
  }

  let token = await storage.getToken();
  let roles = await storage.getRoles();

  if (!token && to.meta.private_route) {
   return next('/authentication/login');
  }

  if ((!roles || !roles.spa_master ||!roles.spa_master.includes('admin')) && to.meta.private_route) {
    return next('/authentication/insufficient-privileges');
  }

  return next();
});

export default router;
